import React, { Component } from 'react';

class ErrorAlert extends Component {

    renderAlertMessage() {
        const {errorMessage} = this.props;
        if(errorMessage && Object.keys(errorMessage).length > 0) {
            return (<div role="alert" className="user-data__error alert alert-error" dangerouslySetInnerHTML={{__html: errorMessage}}></div>);
        }
        return null;
    }

    render() {
        return this.renderAlertMessage();
    }
}
export default ErrorAlert